import type { AdminAbility } from '@repo/sdk/backoffice-abilities'
import type { ReactNode } from 'react'
import { useCan } from '@/modules/permissions/hooks/use-can'
import type { PermissionMode } from '@/modules/permissions/lib/has-admin-ability'

interface Props {
	permissions: AdminAbility[]
	children: ReactNode
	fallback?: ReactNode
	mode?: PermissionMode
}

export function Can({ permissions, children, fallback = null, mode }: Props) {
	const allowed = useCan(permissions, { mode })
	return <>{allowed ? children : fallback}</>
}
